//
// Original collection by Kjetil Midtgarden Golid
// https://github.com/kgolid/chromotome
// https://kgolid.github.io/chromotome-site/
//
export default [
  {
    name: 'dt01',
    colors: ['#172a89', '#f7f7f3'],
    stroke: '#172a89',
    background: '#f3abb0',
    type: 'duotone',
  },
  {
    name: 'dt02',
    colors: ['#302956', '#f3c507'],
    stroke: '#302956',
    background: '#eee3d3',
    type: 'duotone',
  },
  {
    name: 'dt03',
    colors: ['#000000', '#a7a7a7'],
    stroke: '#000000',
    background: '#0a5e78',
    type: 'duotone',
  },
  {
    name: 'dt04',
    colors: ['#50978e', '#f7f0df'],
    stroke: '#000000',
    background: '#f7f0df',
    type: 'duotone',
  },
  {
    name: 'dt05',
    colors: ['#ee5d65', '#f0e5cb'],
    stroke: '#080708',
    background: '#f0e5cb',
    type: 'duotone',
  },
  {
    name: 'dt06',
    colors: ['#271f47', '#e7ceb5'],
    stroke: '#271f47',
    background: '#cc2b1c',
    type: 'duotone',
  },
  {
    name: 'dt07',
    colors: ['#6a98a5', '#d24c18'],
    stroke: '#efebda',
    background: '#efebda',
    type: 'duotone',
  },
  {
    name: 'dt08',
    colors: ['#5d9d88', '#ebb43b'],
    stroke: '#efebda',
    background: '#efebda',
    type: 'duotone',
  },
  {
    name: 'dt09',
    colors: ['#052e57', '#de8d80'],
    stroke: '#efebda',
    background: '#efebda',
    type: 'duotone',
  },
  {
    name: 'dt10',
    colors: ['#e5dfcf', '#151513'],
    stroke: '#151513',
    background: '#e9b500',
    type: 'duotone',
  },
  {
    name: 'dt13',
    colors: ['#f5f2d3', '#f5f2d3', '#fbd6b8'],
    stroke: '#ec5525',
    background: '#ec5525',
    type: 'duotone',
  },
];
